import { useContext } from 'react'
import PropTypes from 'prop-types'
import swal from 'sweetalert2'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileTimes, faPencil, faTrashAlt } from '@fortawesome/pro-light-svg-icons'

import { Box, Link } from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'

import AuthenticatedDownload from '@components/AuthenticatedDownload'

import usePublicationEdition from '@hooks/usePublicationEdition'

const confirmDelete = (deletePublicationEdition, deleteFn) => {
  const publicationEditionPayload = {
    callbacks: {
      action: deleteFn,
    },
    toastText: 'Edition Deleted',
  }

  swal
    .fire({
      title: 'Delete Edition?',
      text: 'Are you sure?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it.',
      confirmButtonColor: '#DD6B55',
    })
    .then(({ value }) => {
      if (value){
        deletePublicationEdition(publicationEditionPayload)
      }
    })
}

const PublicationEditionActions = (props) => {
  const { publicationEdition } = props

  const { callbacks } = useContext(PageContext)
  const { deletePublicationEdition } = callbacks || {}

  const {
    callbacks: { createOrEditPublicationEdition, deletePublicationEdition: deleteFn },
    urls: { inspectionsCsvUrl },
  } = usePublicationEdition(publicationEdition)

  return (
    <Box justifyContent="center">
      <Link greyLink onClick={() => createOrEditPublicationEdition()}>
        <FontAwesomeIcon icon={faPencil} />
      </Link>

      <AuthenticatedDownload>
        <Link greyLink href={inspectionsCsvUrl} textProps={{ marginLeft: 'medium' }}>
          <FontAwesomeIcon icon={faFileTimes} />
        </Link>
      </AuthenticatedDownload>

      <Link
        greyLink
        onClick={() => confirmDelete(deletePublicationEdition, deleteFn)}
        textProps={{ marginLeft: 'medium' }}
      >
        <FontAwesomeIcon icon={faTrashAlt} />
      </Link>
    </Box>
  )
}

PublicationEditionActions.propTypes = {
  publicationEdition: PropTypes.object.isRequired,
}

export default PublicationEditionActions
